import styled from "styled-components";

const SpaceBeetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export default SpaceBeetween;
